// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.creeping-line {
  width: 100%;
  padding-top: 150px;
  padding-bottom: 170px;
  overflow: hidden;
  color: #982D67;
  position: relative;
  z-index: 2;
  background-color: #982D67;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
@media (max-width: 550px) {
  .creeping-line {
    padding-top: 90px;
    padding-bottom: 90px;
  }
}
.creeping-line .creeping-line-box {
  will-change: transform;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.creeping-line .creeping-line-box span {
  display: block;
  margin: 0 10px;
  white-space: nowrap;
  -webkit-text-stroke: 1px #FFFFFF;
  letter-spacing: 2.24px;
  text-transform: uppercase;
  font-family: FixelDisplay;
  font-size: 56px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
}
@media (max-width: 1050px) {
  .creeping-line .creeping-line-box span {
    font-family: FixelDisplay;
    font-size: 35px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
@media (max-width: 550px) {
  .creeping-line .creeping-line-box span {
    font-family: FixelDisplay;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: 100%;
  }
}
.creeping-line .creeping-line-box img {
  width: 35px;
  margin: 0 10px 8px 10px;
  animation: rotatingStar 10s linear infinite;
}
@media (max-width: 550px) {
  .creeping-line .creeping-line-box img {
    width: 20px;
  }
}

@keyframes slide {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
}
@keyframes rotatingStar {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CreepingLine/CreepingLine.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AAIA;EACI,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,cCPS;EDQT,kBAAA;EACA,UAAA;EACA,yBCVS;ECDT,aAAA;EACA,mBFWqB;EEVrB,2BFU0B;EET1B,mBFSsC;AAA1C;AAEI;EAXJ;IAYQ,iBAAA;IACA,oBAAA;EACN;AACF;AACI;EACI,sBAAA;EEpBJ,aAAA;EACA,mBFoByB;EEnBzB,2BFmB8B;EElB9B,mBFkB0C;AAI9C;AAFQ;EACI,cAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;EACA,yBAAA;EEtBR,yBFuB6B;EEtB7B,eFsB2C;EErB3C,kBFqBiD;EEpBjD,gBFoByD;EEnBzD,iBFmB8D;AAQlE;AANY;EATJ;IEhBJ,yBF0BiC;IEzBjC,eFyB+C;IExB/C,kBFwBqD;IEvBrD,gBFuB6D;IEtB7D,iBFsBkE;EAapE;AACF;AAXY;EAbJ;IEhBJ,yBF8BiC;IE7BjC,eF6B+C;IE5B/C,kBF4BqD;IE3BrD,gBF2B6D;IE1B7D,iBF0BkE;EAkBpE;AACF;AAfQ;EACI,WAAA;EACA,uBAAA;EACA,2CAAA;AAiBZ;AAfY;EALJ;IAMQ,WAAA;EAkBd;AACF;;AAVA;EACI;IAEI,wBAAA;EAaN;EAXE;IAEI,4BAAA;EAaN;AACF;AARA;EACI;IACE,uBAAA;EAUJ;EARE;IACE,yBAAA;EAUJ;AACF","sourcesContent":["@use '../../styles/mixins.scss';\n@import '../../styles/variables.scss';\n\n\n.creeping-line {\n    width: 100%;\n    padding-top: 150px;\n    padding-bottom: 170px;\n    overflow: hidden;\n    color: $main-color;\n    position: relative;\n    z-index: 2;\n    background-color: $main-color;\n    @include mixins.flex(row, flex-start, center);\n\n    @media (max-width: 550px) {\n        padding-top: 90px;\n        padding-bottom: 90px;\n    }\n\n    .creeping-line-box {\n        will-change: transform;\n        @include mixins.flex(row, flex-start, center);\n\n        span {\n            display: block;\n            margin: 0 10px;\n            white-space: nowrap;\n            -webkit-text-stroke: 1px $white;\n            letter-spacing: 2.24px;\n            text-transform: uppercase;\n            @include mixins.font(FixelDisplay, 56px, normal, 500, 100%);\n\n            @media (max-width: 1050px) {\n                @include mixins.font(FixelDisplay, 35px, normal, 500, 100%);\n            }\n\n            @media (max-width: 550px) {\n                @include mixins.font(FixelDisplay, 24px, normal, 500, 100%);\n            }\n        }\n    \n        img {\n            width: 35px;\n            margin: 0 10px 8px 10px;\n            animation: rotatingStar 10s linear infinite;\n\n            @media (max-width: 550px) {\n                width: 20px;\n            }\n        }\n    }\n}\n\n\n// Animation Slide\n\n@keyframes slide {\n    from {\n        -webkit-transform: translateX(0);\n        transform: translateX(0);\n    }\n    to {\n        -webkit-transform: translateX(-100%);\n        transform: translateX(-100%);\n    }\n}\n\n// Stars Rotating Animation\n\n@keyframes rotatingStar {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n","// Colors\n\n$main-color: #982D67;\n$white: #FFFFFF;\n$light-background: #F5F5F5;\n$purple: #812456;\n$grey: #EAEAEA;\n$grey-opacity:#E0E0E0;\n$grey-dark: #575756;\n$grey-text: #BCBCBC;\n$dark: #313130;\n$red: #AE2323;\n$opacity-text: rgba(255, 255, 255, 0.50);","@mixin flex($dir, $jc, $ai) {\n    display: flex;\n    flex-direction: $dir;\n    justify-content: $jc;\n    align-items: $ai;\n}\n\n@mixin font ($font, $size, $style, $weight, $height) {\n    font-family: $font;\n    font-size: $size;\n    font-style: $style;\n    font-weight: $weight;\n    line-height: $height;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
